import React from 'react';
import {Spin} from 'antd';
const Loading=({name})=>{
    return <div className='platform-pop-up'>
        <Spin tip={name+'中...'}/>
    </div>
}
export default Loading;